import { FETCH_EPISODES } from 'src/services/GraphQL/Queries/EpisodesQuery';
import { ASSET_SUBTYPE } from 'src/utils/constants/AppConstants';
import { HTTP_HEADER_KEYS } from 'src/utils/constants/HttpMethodsConstants';
import { DisplayLanguage } from 'src/utils/constants/stringConstants';

import { graphQlRequest } from '../../GraphQL/RequestHandler';
import { GQL_QUERIES } from '../../../utils/analytics/newrelic/ErrorTracker';
const generateEpisodesQueryParams = (
  country: string,
  translation: string,
  seasonId: string,
  page: number,
  itemType: string,
  limit: number,
  onAir: boolean
) => {
  const queryParams = {
    filter: {
      country,
      translation,
      seasonId,
      page,
      itemType,
      limit,
      onAir
    }
  };
  return queryParams;
};

export const fetchEpisodes = async (
  country: string,
  translation: string = DisplayLanguage.ENGLISH,
  seasonId: string,
  page: number,
  itemType = ASSET_SUBTYPE.EPISDOE,
  limit = 10,
  onAir = false
): Promise<any> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_EPISODES,
      generateEpisodesQueryParams(
        country,
        translation,
        seasonId,
        page,
        itemType,
        limit,
        onAir
      ),
      GQL_QUERIES.FETCH_EPISODES_QUERY,
      [HTTP_HEADER_KEYS.X_ACCESS_TOKEN]
    );
    return response?.episodes || {};
  } catch (error) {
    console.error('Error while fetching latest episodes: ', error);
    return {};
  }
};
